import { render } from "./xtx-dialog.vue?vue&type=template&id=dbb580e0&scoped=true"
import script from "./xtx-dialog.vue?vue&type=script&lang=js"
export * from "./xtx-dialog.vue?vue&type=script&lang=js"

import "./xtx-dialog.vue?vue&type=style&index=0&id=dbb580e0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb580e0"]])

export default __exports__